<template>
  <div class="threejsContainer">
    <div class="containerTitle">1-9.动态拉伸</div>
    <div ref="container" class="containerBody"></div>
  </div>
</template>

<script>
import * as THREE from 'three';
import {generateScene} from '@/threejsEnv/scene.js';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';

export default {
  data() {
    return {
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      currentMesh: null,
      fullPath: null,
      circleShape: null,
      progress: 0,
      animationId: null
    };
  },
  mounted() {
    // 初始化场景
    this.scene = generateScene();
    this.scene.background = new THREE.Color(0xf0f0f0);

    // 初始化相机
    this.camera = new THREE.PerspectiveCamera(
      75,
      this.$refs.container.clientWidth / this.$refs.container.clientHeight,
      0.1,
      1000
    );
    this.camera.position.set(0, 5, 10);

    // 初始化渲染器
    this.renderer = new THREE.WebGLRenderer({ antialias: true });
    this.renderer.setSize(
      this.$refs.container.clientWidth,
      this.$refs.container.clientHeight
    );
    this.$refs.container.appendChild(this.renderer.domElement);

    // 添加轨道控制器
    this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    this.controls.enableDamping = true;

    // 创建光源
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
    this.scene.add(ambientLight);
    
    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
    directionalLight.position.set(10, 20, 15);
    this.scene.add(directionalLight);

    // 定义二维截面（圆形）
    this.circleShape = new THREE.Shape();
    this.circleShape.absarc(0, 0, 0.2, 0, Math.PI * 2);

    // 定义完整路径（三维曲线）
    this.fullPath = new THREE.CatmullRomCurve3([
      new THREE.Vector3(-4, 0, 0),
      new THREE.Vector3(-1, 0, 0),
      new THREE.Vector3(-1, 3, 0),
      new THREE.Vector3(2, 3, 0),
      new THREE.Vector3(2, 0, 0),
      new THREE.Vector3(2, 0, 3)
    ]);
    this.fullPath.tension = 0;

    // 添加路径辅助线
    const lineGeometry = new THREE.BufferGeometry().setFromPoints(this.fullPath.getPoints(100));
    const lineMaterial = new THREE.LineBasicMaterial({ color: 0x0000ff, linewidth: 2 });
    const line = new THREE.Line(lineGeometry, lineMaterial);
    this.scene.add(line);

    // 启动动画
    this.animate();

    // 监听窗口大小变化
    window.addEventListener('resize', this.onWindowResize);
  },
  methods: {
    animate() {
      this.animationId = requestAnimationFrame(this.animate);
      
      // 更新进度（0到1之间）
      if (this.progress < 1) {
        this.progress = Math.min(this.progress + 0.02, 1);
        this.updateExtrudeMesh();
      }

      this.controls.update();
      this.renderer.render(this.scene, this.camera);
    },

    updateExtrudeMesh() {
      // 移除旧模型并释放资源
      if (this.currentMesh) {
        this.scene.remove(this.currentMesh);
        this.currentMesh.geometry.dispose();
        this.currentMesh.material.dispose();
      }

      // 根据进度截取路径片段
      const points = this.fullPath.getPoints(200);
      const partialPoints = points.slice(0, Math.ceil(points.length * this.progress));
      
      // 创建部分路径
      const partialPath = new THREE.CurvePath();
      for (let i = 0; i < partialPoints.length - 1; i++) {
        partialPath.add(new THREE.LineCurve3(partialPoints[i], partialPoints[i + 1]));
      }

      // 配置拉伸参数
      const extrudeSettings = {
        extrudePath: partialPath,
        steps: 400,
        curveSegments: 3,
        bevelEnabled: false
      };

      // 创建拉伸几何体
      const geometry = new THREE.ExtrudeGeometry(this.circleShape, extrudeSettings);
      const material = new THREE.MeshStandardMaterial({
        color: 0xff5533,
        metalness: 0.3,
        roughness: 0.7
      });

      // 创建新模型并添加到场景
      this.currentMesh = new THREE.Mesh(geometry, material);
      this.scene.add(this.currentMesh);
    },

    onWindowResize() {
      const width = this.$refs.container.clientWidth;
      const height = this.$refs.container.clientHeight;

      // 更新相机
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();

      // 更新渲染器
      this.renderer.setSize(width, height);
    }
  },
  beforeDestroy() {
    // 清理动画和事件监听
    cancelAnimationFrame(this.animationId);
    window.removeEventListener('resize', this.onWindowResize);
    
    // 释放资源
    if (this.currentMesh) {
      this.scene.remove(this.currentMesh);
      this.currentMesh.geometry.dispose();
      this.currentMesh.material.dispose();
    }
    
    this.controls.dispose();
    this.renderer.dispose();
    this.renderer.domElement.remove();
  }
};
</script>

<style>
</style>
